import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute = ({ children, requireAdmin = false, requireManagerOrAdmin = false, requireAnalyzerAccess = false }) => {
  const { user, loading, isAuthenticated, isAdmin, isManagerOrAdmin, canAccessAnalyzer } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireManagerOrAdmin && !isManagerOrAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAnalyzerAccess && !canAccessAnalyzer) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
